import React from 'react';
import PropTypes from 'prop-types';
import { formatDateTime, relativeTimeLabel } from './tabFormatters';

// "Interviewed" column — senior_level_flow's Completed ("Final Call") tab
// only, off the candidate-list API's own row.completed_interview_rounds:
//   [{ interview_round_detail_id, round_number, interview_time,
//      verdict_counts: { advance, reject, hold, pending } }]
// A candidate can carry more than one completed round; this cell surfaces
// the latest one (by round_number, not array position — order isn't
// guaranteed) since that is the round the Final Call decision is actually
// made on. See PanelVerdictCell.jsx for the tally read off the same round.
export const latestCompletedRound = (rounds) =>
  (rounds || []).reduce(
    (best, r) =>
      !best || (r.round_number || 0) > (best.round_number || 0) ? r : best,
    null
  );

const CompletedInterviewCell = ({ row }) => {
  const rounds = row.completed_interview_rounds || [];
  const round = latestCompletedRound(rounds);

  if (!round) {
    return <span className="text-sm text-muted-foreground">—</span>;
  }

  const dateTime = formatDateTime(round.interview_time);
  const relative = relativeTimeLabel(round.interview_time);

  return (
    <div className="min-w-0">
      <p className="text-xs font-semibold text-foreground-strong whitespace-nowrap">
        {dateTime || '—'}
      </p>
      {relative && (
        <p className="text-xs text-muted-foreground mt-1 whitespace-nowrap">
          {relative}
        </p>
      )}
    </div>
  );
};

CompletedInterviewCell.propTypes = {
  row: PropTypes.shape({
    completed_interview_rounds: PropTypes.arrayOf(
      PropTypes.shape({
        interview_round_detail_id: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
        ]),
        round_number: PropTypes.number,
        interview_time: PropTypes.string,
      })
    ),
  }).isRequired,
};

export const completedInterviewColumn = {
  key: 'completed_interview',
  header: 'Interviewed',
  className: 'text-sm',
  // Left-aligned per the rest of senior_level_flow's columns — see
  // seniorFlowTabFactory.jsx's own comment on this.
  align: 'left',
  width: '190px',
  render: (_v, row) => <CompletedInterviewCell row={row} />,
};

export default CompletedInterviewCell;
